import { render, staticRenderFns } from "./DeepLinkLanding.vue?vue&type=template&id=48fc26dd&scoped=true"
import script from "./DeepLinkLanding.vue?vue&type=script&lang=js"
export * from "./DeepLinkLanding.vue?vue&type=script&lang=js"
import style0 from "./DeepLinkLanding.vue?vue&type=style&index=0&id=48fc26dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc26dd",
  null
  
)

export default component.exports